import ListAltIcon from "@mui/icons-material/ListAlt";
import ListReportEdition from "./List";

//params
export const REPORT_EDITIONS = "editions/reference";

//permissions

export const resources = {
  isMenu: true,
  icon: <ListAltIcon />,
  name: REPORT_EDITIONS,
  title: "Справка издания",
  list: <ListReportEdition />,
  permission: "editions",
};

//api url
